import { render, staticRenderFns } from "./safetyGearRequestGiveDetail.vue?vue&type=template&id=56734d92"
import script from "./safetyGearRequestGiveDetail.vue?vue&type=script&lang=js"
export * from "./safetyGearRequestGiveDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56734d92')) {
      api.createRecord('56734d92', component.options)
    } else {
      api.reload('56734d92', component.options)
    }
    module.hot.accept("./safetyGearRequestGiveDetail.vue?vue&type=template&id=56734d92", function () {
      api.rerender('56734d92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/sas/safetyGearRequestGiveDetail.vue"
export default component.exports